import { render, staticRenderFns } from "./create-company-modal.vue?vue&type=template&id=27b8e3ed&scoped=true&"
import script from "./create-company-modal.vue?vue&type=script&lang=js&"
export * from "./create-company-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b8e3ed",
  null
  
)

export default component.exports